import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch
} from 'react-router-dom';

import firebase from './config/firebase';
import Login from './components/Login';
import App from './components/App';

const Register = () => <div>Register</div>;

const getUser = () => firebase.auth.currentUser;

/**
 * Route config
 * add `requiresAuth: true` to have routes protected
 *
 * add routes: [{ path: '/users/:id', component: User }]
 * you will need to add a sub-router to your component when using sub-routes
 *
 * add exact: true if you need the url to match exactly
 *
 * add params - path: "user/:group/:id"
 * this will be available on the component as
 * this.props.match.params.group & this.props.match.params.id
 *
 */
const routes = [
  {
    path: '/login',
    component: Login
  },
  {
    path: '/register',
    component: Register
  },
  {
    path: '/',
    component: App,
    requiresAuth: true
  }
];

export const CustomRoute = ({
  component: Component,
  requiresAuth = false,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (requiresAuth) {
        return getUser() ? (
          <Component {...props} routes={routes} />
        ) : (
          <Redirect to="/login" />
        );
      }
      return <Component {...props} routes={routes} />;
    }}
  />
);

const RouteConfigExample = props => (
  <Router>
    <Switch>
      {routes.map((route, i) => (
        <CustomRoute key={i} {...route} />
      ))}
    </Switch>
  </Router>
);

export default RouteConfigExample;
